import './SidebarMobileHeader.css'
import forvetLogo from '../../../assets/Sidebar/forvet_logo_white.svg'
import AppContext from '../../../contexts/AppContext';
import { useContext } from 'react';
import { Burger } from '@mantine/core';
import { Link } from 'react-router-dom';

export default function SidebarMobileHeader() {
   const { setIsNavbarOpen, isNavbarOpen } = useContext(AppContext);
   return (
      <header className='sidebar-mobile-header-container'>
         <Link to='/campus/dashboard'>
            < img className='sidebar-logo-image' src={forvetLogo} alt='logo de FORVET' />
         </Link>
         <Burger color='#fff' size={32} opened={isNavbarOpen} onClick={() => {
            setIsNavbarOpen(!isNavbarOpen)
         }} aria-label="Toggle navigation" />
      </header>
   )
}
